import { ReactNode, useContext } from 'react';
import { css as emotionCSS } from '@emotion/react';
import { Typography } from '@mildang/mui';
import { DocumentContext, generateVariantValues } from './DocumentContext';

const rootStyle = emotionCSS`
  margin-top: 18px;
  margin-bottom: 18px;
`;

const Text = ({ children }: { children: ReactNode }) => {
  const { variant } = useContext(DocumentContext);

  return (
    <Typography
      variant={generateVariantValues({
        screen: 'body1' as const,
        dialog: 'body2' as const,
      })(variant)}
      css={rootStyle}
    >
      {children}
    </Typography>
  );
};

export default Text;
